<template>
    <div class="theoryQuestionBank">
        <theoryDetail v-if="id == 2"></theoryDetail>
        <keep-alive>
            <theoryList v-if="id != 2"></theoryList>
        </keep-alive>
    </div>
</template>

<script>
import theoryList from './theoryList';
import theoryDetail from './theoryDetail';
export default {
    name: 'specialReport',
    data() {
        return {}
    },
    components: {
        theoryList,
        theoryDetail
    },
    computed: {
        id() {
            return this.$route.query.id
        }
    }
}
</script>

<style lang="scss" scoped></style>